// MT Image List 1 - JavaScript for horizontal scrolling navigation and video control
class MTImageList1 {
  constructor(container) {
    this.container = container;
    this.scrollContainer = container.querySelector('.mt-image-list1__scroll');
    this.prevBtn = container.querySelector('.mt-image-list1__nav--prev');
    this.nextBtn = container.querySelector('.mt-image-list1__nav--next');
    this.cards = container.querySelectorAll('.mt-image-list1__card');
    this.youtubeAPIsReady = false;
    this.youtubePlayers = new Map();
    
    if (!this.scrollContainer || !this.prevBtn || !this.nextBtn) return;
    
    this.init();
  }

  init() {
    this.updateNavButtons();
    this.bindEvents();
    this.initVideos();
    this.loadYouTubeAPI();
  }

  bindEvents() {
    // Navigation button clicks
    this.prevBtn.addEventListener('click', () => this.scroll('prev'));
    this.nextBtn.addEventListener('click', () => this.scroll('next'));

    // Update buttons on scroll
    this.scrollContainer.addEventListener('scroll', () => {
      this.updateNavButtons();
    });

    // Update buttons on window resize
    window.addEventListener('resize', () => {
      this.updateNavButtons();
    });

    // Touch events for mobile swipe (optional enhancement)
    let startX = 0;
    let scrollLeft = 0;

    this.scrollContainer.addEventListener('touchstart', (e) => {
      startX = e.touches[0].pageX;
      scrollLeft = this.scrollContainer.scrollLeft;
    });

    this.scrollContainer.addEventListener('touchmove', (e) => {
      if (!startX) return;
      const x = e.touches[0].pageX;
      const walk = (startX - x) * 2;
      this.scrollContainer.scrollLeft = scrollLeft + walk;
    });
  }

  initVideos() {
    this.cards.forEach(card => {
      const video = card.querySelector('.mt-image-list1__video');
      const videoWrapper = card.querySelector('.mt-image-list1__video-wrapper');
      const playBtn = card.querySelector('.mt-image-list1__play-btn');
      
      // Handle local videos
      if (video) {
        // Hover to play, leave to pause
        card.addEventListener('mouseenter', () => {
          video.play().catch(e => console.log('Video play failed:', e));
        });

        card.addEventListener('mouseleave', () => {
          video.pause();
        });

        // Click to toggle play/pause
        video.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        });
      }

      // Handle YouTube videos with poster
      if (videoWrapper && playBtn && videoWrapper.dataset.videoType === 'youtube') {
        const videoId = videoWrapper.dataset.videoId;
        
        playBtn.addEventListener('click', () => {
          this.playYouTubeVideo(videoWrapper, videoId);
        });
      }
    });
  }

  loadYouTubeAPI() {
    // Check if any YouTube videos without posters exist
    const youtubeIframes = this.container.querySelectorAll('.mt-image-list1__video-iframe');
    if (youtubeIframes.length === 0) return;

    // Load YouTube IFrame API
    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      window.onYouTubeIframeAPIReady = () => {
        this.youtubeAPIsReady = true;
        this.initYouTubePlayers();
      };
    } else if (window.YT && window.YT.Player) {
      this.youtubeAPIsReady = true;
      this.initYouTubePlayers();
    }
  }

  initYouTubePlayers() {
    const youtubeIframes = this.container.querySelectorAll('.mt-image-list1__video-iframe');
    
    youtubeIframes.forEach((iframe, index) => {
      const card = iframe.closest('.mt-image-list1__card');
      const playerId = `yt-player-${this.container.dataset.sectionId || 'default'}-${index}`;
      iframe.id = playerId;

      const player = new YT.Player(playerId, {
        events: {
          'onReady': (event) => {
            this.youtubePlayers.set(playerId, event.target);
            
            // Hover to play
            card.addEventListener('mouseenter', () => {
              event.target.playVideo();
            });

            card.addEventListener('mouseleave', () => {
              event.target.pauseVideo();
            });
          }
        }
      });
    });
  }

  playYouTubeVideo(wrapper, videoId) {
    const iframe = document.createElement('iframe');
    iframe.className = 'mt-image-list1__video-iframe';
    iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&rel=0&modestbranding=1&controls=1`;
    iframe.frameBorder = '0';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;

    wrapper.innerHTML = '';
    wrapper.appendChild(iframe);
    wrapper.closest('.mt-image-list1__card').classList.add('video-playing');
  }

  scroll(direction) {
    const cardWidth = this.cards[0]?.offsetWidth || 430;
    const gap = 24;
    const scrollAmount = cardWidth + gap;

    if (direction === 'prev') {
      this.scrollContainer.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });
    } else {
      this.scrollContainer.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  }

  updateNavButtons() {
    const { scrollLeft, scrollWidth, clientWidth } = this.scrollContainer;
    
    // Hide prev button at start (first slide)
    if (scrollLeft <= 10) {
      this.prevBtn.disabled = true;
      this.prevBtn.style.opacity = '0';
      this.prevBtn.style.visibility = 'hidden';
      this.prevBtn.style.pointerEvents = 'none';
    } else {
      this.prevBtn.disabled = false;
      this.prevBtn.style.opacity = '';
      this.prevBtn.style.visibility = '';
      this.prevBtn.style.pointerEvents = '';
    }

    // Hide next button at end (last slide)
    if (scrollLeft + clientWidth >= scrollWidth - 10) {
      this.nextBtn.disabled = true;
      this.nextBtn.style.opacity = '0';
      this.nextBtn.style.visibility = 'hidden';
      this.nextBtn.style.pointerEvents = 'none';
    } else {
      this.nextBtn.disabled = false;
      this.nextBtn.style.opacity = '';
      this.nextBtn.style.visibility = '';
      this.nextBtn.style.pointerEvents = '';
    }
  }
}

// Initialize all instances when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.mt-image-list1');
  containers.forEach(container => {
    new MTImageList1(container);
  });
});

// Reinitialize on Shopify theme editor events
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target.querySelector('.mt-image-list1');
    if (container) {
      new MTImageList1(container);
    }
  });
}
